<template>
	<StandardModal
		class="code-form-modal"
		small
		open
		:title="$t('groupinvites_join_title')"
		:confirmText="$t('common_button_continue')"
		:confirmProps="{ disabled: !code }"
		@confirm="$emit('code', code)"
		@cancel="$emit('cancel')"
	>
		<CodeForm v-model="code" />
	</StandardModal>
</template>

<script>
import { StandardModal } from '@/components/common'
import CodeForm from './CodeForm'

export default {
	name: 'InviteCodeModal',
	components: { StandardModal, CodeForm },
	data() {
		return {
			code: null,
		}
	},
	emits: ['code', 'cancel'],
	methods: {
		goToInvite() {},
	},
}
</script>

<style lang="scss">
.code-form-modal {
	.modal-body {
		padding: 24px;
	}
}
</style>
